/* Pinnacle Garage USA - site-wide polish script (loaded by snippets/pg-polish.liquid). */
(function () {
/* 4. photo dots stay hidden; they fade in while the photo is swiped / changed and fade out again after */
var DOTS = '.pgx-dots, .pgwp-dots, .pgbp-dots', tmr = null, cur = null, sx = null, sy = null;
function holderFor(t) {
var el = t && t.closest && t.closest('.card__inner, .card__media, .pgwp-img, .pgbp-img, [class*="-img"], [class*="media"]');
while (el) { var d = el.querySelector(DOTS); if (d) return d.parentElement; if (el.matches('li, .card-wrapper, .pgwp-card, .pgbp-card')) return null; el = el.parentElement; }
return null;
}
function flash(h) {
if (!h) return; clearTimeout(tmr);
if (cur && cur !== h) cur.classList.remove('pg-dots-on');
cur = h; h.classList.add('pg-dots-on');
tmr = setTimeout(function () { if (cur) cur.classList.remove('pg-dots-on'); cur = null; }, 1300);
}
document.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
document.addEventListener('touchmove', function (e) {
if (sx === null) return;
var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) { var h = holderFor(e.target); if (h) { flash(h); clearTimeout(tmr); } }
}, { passive: true });
document.addEventListener('touchend', function () { sx = null; if (cur) flash(cur); }, { passive: true });
/* the active dot changes (swipe, arrow click) -> show the dots for a moment */
new MutationObserver(function (ms) {
for (var i = 0; i < ms.length; i++) {
var t = ms[i].target, p = t.parentElement;
if (p && p.matches && p.matches(DOTS) && t.classList.contains('on')) { flash(p.parentElement); break; }
}
}).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
ready(function () {
/* 5. "First time buyer?" tab sits above Log in while the mobile menu is open */
var det = document.querySelector('header-drawer details, #Details-menu-drawer-container');
function placeTab() {
var tab = document.getElementById('pgnl-tab'); if (!tab) return;
var open = det && det.hasAttribute('open') && window.innerWidth < 990;
if (!open) { tab.style.bottom = ''; tab.style.opacity = ''; tab.style.pointerEvents = ''; return; }
var acc = document.querySelector('.menu-drawer__account, .menu-drawer__utility-links');
if (!acc) return;
var top = acc.getBoundingClientRect().top;
tab.style.bottom = Math.max(16, window.innerHeight - top + 14) + 'px';
var low = 0;
document.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li').forEach(function (li) { var r = li.getBoundingClientRect(); if (r.height && r.bottom > low && r.bottom < top) low = r.bottom; });
var room = top - 14 - tab.offsetHeight - low;
tab.style.opacity = room < 0 ? '0' : ''; tab.style.pointerEvents = room < 0 ? 'none' : '';
}
if (det) {
new MutationObserver(function () { placeTab(); setTimeout(placeTab, 320); }).observe(det, { attributes: true, attributeFilter: ['open'] });
window.addEventListener('resize', placeTab);
}
/* 6. bottom collection description: same left edge + width as the product grid */
var desc = document.querySelector('.collection-description');
var gridBox = function () { return document.getElementById('ProductGridContainer') || document.querySelector('.pg-sf-results, #product-grid'); };
function align() {
var g = gridBox(); if (!desc || !g) return;
desc.classList.add('pg-desc-al');
desc.style.marginLeft = '0px'; desc.style.width = '';
var gr = g.getBoundingClientRect(), pr = desc.parentElement.getBoundingClientRect();
if (!gr.width) return;
desc.style.marginLeft = Math.round(gr.left - pr.left) + 'px';
desc.style.width = Math.round(gr.width) + 'px';
}
if (desc) {
align(); window.addEventListener('load', align); window.addEventListener('resize', align);
if (window.ResizeObserver) { var ro = new ResizeObserver(align); var g0 = gridBox(); if (g0) ro.observe(g0); }
}
/* 7. Title Case for short labels */
var SMALL = { a: 1, an: 1, and: 1, the: 1, to: 1, 'for': 1, of: 1, on: 1, per: 1, 'with': 1, or: 1, at: 1, by: 1, via: 1, 'in': 1 };
function tc(s) {
return s.replace(/[A-Za-z][A-Za-z'’]*(-[A-Za-z]+)*/g, function (w, _x, off) {
var first = off === 0 || /[:?.!·—]\s*$/.test(s.slice(0, off));
if (/[A-Z]/.test(w.slice(1)) || /^[A-Z]{2,}$/.test(w)) return w;
var lw = w.toLowerCase();
if (!first && SMALL[lw]) return lw;
return lw.split('-').map(function (p) { return p.charAt(0).toUpperCase() + p.slice(1); }).join('-');
});
}
var LIST = [
'in stock', 'out of stock', 'sold out', 'in stock only', 'view cart', 'check out', 'continue shopping', 'shop all wheels →', 'shop all →',
'free shipping', 'on all us orders', 'fitment help', 'ships in 1–2 business days', 'copy link', 'view full details', 'check fit', 'view all',
'members only', 'off your first order', 'unlock my 5% code', 'new wheel drops first', 'restock alerts', 'member-only deals',
'one-time use per email · storewide · unsubscribe anytime.', 'no thanks, i’ll pay full price', 'here’s 5% off your first order', 'copy code',
'start shopping', 'first time buyer?', 'tap to claim 5% off', 'find wheels for your car', 'select your vehicle to see only the wheels that fit.',
'show wheels', 'all bolt patterns', 'price: low to high', 'price: high to low', 'shop for your vehicle', 'select your car to see only the parts that fit.',
'show parts', 'remove all', 'match all', 'show more', 'show less', 'product type', 'need help choosing?', 'see the sizes and offsets your car can run',
'talk to a fitment expert', 'pay over time', 'financing available with affirm', 'visit our showroom', 'your cart', 'your cart is empty',
'have an account?', 'order special instructions', 'estimated total', 'wheels · body kits · performance', 'subscribe to receive the latest updates and promotions.',
'does this fit your vehicle?', 'select your car', 'check your vehicle', 'add to cart', 'buy it now', 'shop by vehicle', 'shop wheels by model', 'show all wheels', 'clear all',
'you may also like', 'recently viewed', 'related products', 'back to top', 'contact us', 'send message', 'quick view', 'load more', 'apply filters',
'sort by', 'filter and sort', 'check your inbox', 'you’re in', 'enter your email', 'suggested for you'
];
var SET = {}; LIST.forEach(function (x) { SET[x] = 1; });
var RX = [/^view all \d+ products$/i, /^.{2,40} \(\d+ products?\)$/i, /^only \d+ sets? remaining$/i, /^\d+ (products|wheels shown|finishes)$/i];
function want(t) { var l = t.toLowerCase(); if (SET[l]) return true; for (var i = 0; i < RX.length; i++) if (RX[i].test(t)) return true; return false; }
function run(root) {
if (!root || root.nodeType !== 1) return;
var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
while ((n = w.nextNode())) list.push(n);
list.forEach(function (n) {
var p = n.parentNode; if (!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION|TITLE)$/.test(p.nodeName)) return;
if (p.closest && p.closest('.rte, .collection-description, .product__description, [contenteditable]')) return;
var raw = n.nodeValue, t = raw.trim().replace(/\s+/g, ' ');
if (t.length < 4 || t.length > 70 || !want(t)) return;
var nt = tc(t); if (nt !== t) n.nodeValue = raw.replace(raw.trim(), nt);
});
root.querySelectorAll && root.querySelectorAll('input[placeholder]').forEach(function (i) { if (want(i.placeholder)) i.placeholder = tc(i.placeholder); });
}
run(document.body);
var q = [], pend = false;
new MutationObserver(function (ms) {
ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1) q.push(x); else if (x.nodeType === 3 && x.parentNode) q.push(x.parentNode); }); if (m.type === 'characterData' && m.target.parentNode) q.push(m.target.parentNode); });
if (pend) return; pend = true;
setTimeout(function () { pend = false; var l = q; q = []; l.forEach(function (x) { if (x.isConnected) run(x); }); }, 40);
}).observe(document.body, { childList: true, subtree: true, characterData: true });
window.PG_TITLECASE = tc;
/* 12. Grid / Small grid / List choice is kept on the next page (and while browsing) until the customer switches back */
function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
var applying = false;
document.addEventListener('change', function (e) {
if (!applying && e.target.matches && e.target.matches('.pgx-view select')) sset('pgViewKeep', e.target.value);
}, true);
var keep = sget('pgViewKeep');
if (keep && keep !== 'grid') {
var tries = 0, iv = setInterval(function () {
var s = document.querySelector('.pgx-view select');
if (s) {
clearInterval(iv);
if (s.value !== keep && [].some.call(s.options, function (o) { return o.value === keep; })) {
applying = true; s.value = keep; s.dispatchEvent(new Event('change', { bubbles: true })); applying = false;
}
} else if (++tries > 50) clearInterval(iv);
}, 100);
}
/* 13. remember what the customer searched for (used for the cart suggestions below) */
function lget(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
function lset(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
if (location.pathname === '/search') {
var qq = (new URLSearchParams(location.search).get('q') || '').trim();
if (qq.length > 1) { var ss = (lget('pgSearches') || []).filter(function (x) { return x.toLowerCase() !== qq.toLowerCase(); }); ss.unshift(qq); lset('pgSearches', ss.slice(0, 6)); }
}
/* 14. cart: if the customer clears Recently Viewed, show 4 suggested products based on what they viewed + searched */
var rv = document.querySelector('[data-pg-rv]');
if (rv && /^\/cart/.test(location.pathname)) {
var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
var money = function (v) { var n = typeof v === 'number' ? v / 100 : parseFloat(v); return isNaN(n) ? '' : '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD'; };
var img = function (u, w) { if (!u) return ''; u = String(u); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
var card = function (p) {
var i1 = p.featured_image || (p.images && p.images[0]) || (p.image) || '', i2 = (p.images && p.images[1]) || '';
if (i1 && typeof i1 === 'object') i1 = i1.src || i1.url; if (i2 && typeof i2 === 'object') i2 = i2.src || i2.url;
var url = (p.url || ('/products/' + p.handle)).split('?')[0];
var price = p.price_min != null ? p.price_min : p.price, cmp = p.compare_at_price_min || p.compare_at_price_max || p.compare_at_price;
var sale = cmp && parseFloat(cmp) > parseFloat(price);
var imgs = i1 ? '<img src="' + esc(img(i1, 600)) + '" alt="' + esc(p.title) + '" class="motion-reduce" loading="lazy" width="600" height="600">' + (i2 ? '<img src="' + esc(img(i2, 600)) + '" alt="" class="motion-reduce" loading="lazy" width="600" height="600">' : '') : '';
var pr = '<div class="price' + (sale ? ' price--on-sale' : '') + '"><div class="price__container">' + (sale
? '<div class="price__sale"><span class="price-item price-item--sale price-item--last">' + money(price) + '</span> <s class="price-item price-item--regular">' + money(cmp) + '</s></div>'
: '<div class="price__regular"><span class="price-item price-item--regular">' + money(price) + '</span></div>') + '</div></div>';
return '<li class="grid__item"><div class="card-wrapper product-card-wrapper underline-links-hover"><div class="card card--standard card--media" style="--ratio-percent: 100%;">' +
'<div class="card__inner gradient ratio" style="--ratio-percent: 100%;">' + (imgs ? '<div class="card__media"><div class="media media--transparent' + (i2 ? ' media--hover-effect' : '') + '">' + imgs + '</div></div>' : '') +
'<div class="card__content"><div class="card__information"><h3 class="card__heading"><a href="' + esc(url) + '" class="full-unstyled-link">' + esc(p.title) + '</a></h3></div></div></div>' +
'<div class="card__content"><div class="card__information"><h3 class="card__heading h5"><a href="' + esc(url) + '" class="full-unstyled-link">' + esc(p.title) + '</a></h3><div class="card-information">' + pr + '</div></div></div></div></div></li>';
};
var suggest = function () {
var seen = lget('pgRvSeen') || [], searches = lget('pgSearches') || [];
var skip = {}; seen.forEach(function (x) { skip[x.id] = 1; skip[(x.u || '').split('?')[0]] = 1; });
document.querySelectorAll('.cart-item a[href*="/products/"], cart-items a[href*="/products/"]').forEach(function (a) { skip[a.getAttribute('href').split('?')[0]] = 1; });
var jobs = [];
seen.slice(0, 3).forEach(function (x) { if (x.id) jobs.push(fetch('/recommendations/products.json?product_id=' + x.id + '&limit=8&intent=related').then(function (r) { return r.json(); }).then(function (j) { return j.products || []; }).catch(function () { return []; })); });
searches.slice(0, 2).forEach(function (q) { jobs.push(fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8').then(function (r) { return r.json(); }).then(function (j) { return (j.resources && j.resources.results && j.resources.results.products) || []; }).catch(function () { return []; })); });
if (!jobs.length) jobs.push(fetch('/collections/all-products/products.json?limit=12').then(function (r) { return r.json(); }).then(function (j) { return (j.products || []).map(function (p) { return { id: p.id, handle: p.handle, title: p.title, images: (p.images || []).map(function (i) { return i.src; }), price: p.variants && p.variants[0] && p.variants[0].price, compare_at_price: p.variants && p.variants[0] && p.variants[0].compare_at_price }; }); }).catch(function () { return []; }));
Promise.all(jobs).then(function (lists) {
var out = [], used = {}, i = 0, more = true;
while (out.length < 4 && more) {
more = false;
lists.forEach(function (l) {
if (out.length >= 4 || i >= l.length) return; more = true;
var p = l[i], key = (p.url || '/products/' + p.handle).split('?')[0];
if (p.available === false || used[key] || skip[key] || skip[p.id]) return;
used[key] = 1; out.push(p);
});
i++;
}
if (!out.length) return;
rv.querySelector('.pg-rv__title').textContent = 'Suggested for You';
var clr = rv.querySelector('[data-rv-clear]'); if (clr) clr.hidden = true;
rv.querySelector('[data-rv-list]').innerHTML = out.map(card).join('');
rv.hidden = false; rv.classList.add('pg-rv--suggest');
});
};
/* clearing: keep a private note of what was viewed so the suggestions can be based on it */
rv.addEventListener('click', function (e) {
if (!e.target.closest('[data-rv-clear]')) return;
var before = lget('pgRecent') || []; if (before.length) lset('pgRvSeen', before.slice(0, 6));
setTimeout(suggest, 30);
}, true);
/* already cleared on an earlier visit: suggestions instead of an empty space */
setTimeout(function () {
var has = rv.querySelector('[data-rv-list] li');
if ((!has || rv.hidden) && lget('pgRvSeen')) suggest();
}, 600);
}
});
})();